import {
    Grid,
    Container,
    Box,
    Link,
    Typography,
    Button,
} from "@material-ui/core";
import { makeStyles } from '@material-ui/core/styles';

function Copyright() {
    return (
      <Typography variant="body2" align="center" style={{color:'#fff'}}>
        {'Copyright © '}
        <Link color="inherit" href="/" underline="none">
          VLearnAI
        </Link>{' '}
        {new Date().getFullYear()}
        {'.'}
      </Typography>
    );
  }
  
const useStyles = makeStyles((theme) => ({
    icon: {
      marginRight: theme.spacing(2),
    },
    heroContent: {
      backgroundColor: theme.palette.background.paper,
      padding: theme.spacing(8, 0, 6),
    },
    heroButtons: {
      marginTop: theme.spacing(4),
    },
    cardGrid: {
      paddingTop: theme.spacing(8),
      paddingBottom: theme.spacing(8),
    },
    card: {
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
    },
    cardMedia: {
      paddingTop: '56.25%', // 16:9
    },
    cardContent: {
      flexGrow: 1,
    },
    footer: {
      backgroundColor: "#82A4A0",
      padding: theme.spacing(6),
      color: "#fff",
    },
  }));
  

export default function Footer(){
    const classes = useStyles();
    return(
    <footer className={classes.footer}>
        <Box>
            <Container maxwidth="lg">
                <Grid container spacing={5}>
                    <Grid item xs={12} sm={4}>
                        <Box borderBottom={1} mt={3} mb={3}>Background</Box>
                        <Box>
                            <Link href="/about" color="inherit">
                                About Us
                            </Link>
                        </Box>
                        <Box>
                            <Link href="/about" color="inherit">
                                Research Group
                            </Link>
                        </Box>
                        <Box>
                            <Link href="#" color="inherit">
                                Blog
                            </Link>
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <Box borderBottom={1} mt={3} mb={3}>Help and Support</Box>
                        <Box>
                            <Link href="#" color="inherit">
                                Contact Us
                            </Link>
                        </Box>
                        <Box>
                            <Link href="#" color="inherit">
                                Community
                            </Link>
                        </Box>
                        <Box>
                            <Link href="#" color="inherit">
                                Questions
                            </Link>
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <Box borderBottom={1} mt={3} mb={3}>Join Us</Box>
                        <Box>
                            <Link href="#" color="inherit">
                                Resgiter as Student
                            </Link>
                        </Box>
                        <Box>
                            <Link href="#" color="inherit">
                                Become Instructor
                            </Link>
                        </Box>
                        <Box>
                            <Link href="#" color="inherit">
                                Affiliate
                            </Link>
                        </Box>
                    </Grid>
                </Grid>
            </Container>
            <Box mt={5} p={3}>
                 <Copyright />
            </Box>
        </Box>

    </footer>
    );
}